import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/endPoints/checkMFAEnabled/type';

export const checkMFAEnabled = ({ email }: QueryParams) => {
    const url = `admin/bo/checkMFAEnabled/${email}`;
    return network.get<QueryFnResponse>(url).then((response) => {
        return response.data;
    });
};
